<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    :width="width"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="appendToBody"
    @close="handleClose"
  >
    <slot></slot>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        v-if="isHasCancelBtn"
        @click="handleClose"
        >{{ cancelText }}</el-button
      >
      <el-button
        v-if="isHasConfirmBtn"
        type="primary"
        :disabled="disabledBtn"
        @click="handleConfirm"
        >{{ confirmText }}</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'EDialog',
  props: {
    title: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '580px'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    confirmText: {
      type: String,
      default: '确定'
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    isHasCancelBtn: {
      type: Boolean,
      default: true
    },
    isHasConfirmBtn: {
      type: Boolean,
      default: true
    },
    appendToBody: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false
    };
  },
  computed: {
    disabledBtn() {
      return this.disabled;
    }
  },
  methods: {
    open() {
      this.dialogVisible = true;
    },
    close() {
      this.dialogVisible = false;
    },
    handleClose() {
      this.close();
      this.$emit('close');
    },
    handleConfirm() {
      this.$emit('confirm');
    }
  }
};
</script>
<style lang="less" scoped>
:deep(.el-dialog) {
  border-radius: 8px;
  .el-dialog__header,
  .el-dialog__footer {
    padding: 24px;
  }
  .el-dialog__body {
    padding: 0 24px;
    max-height: 500px;
    overflow: auto;
  }
  .el-dialog__headerbtn {
    top: 24px;
  }
  .el-button {
    height: 36px;
    padding: 0 24px;
  }
  .el-dialog__title {
    font-size: 16px;
    color: @content-color;
    font-weight: bold;
  }
  .el-dialog__close {
    color: @content-color;
    font-size: 20px;
  }
  .el-form.el-form--label-top {
    .el-form-item {
      margin-bottom: 20px;
      &.is-error {
        margin-bottom: 32px;
      }
      .el-form-item__label {
        line-height: normal;
        padding: 0 0 8px;
        color: @content-color;
      }
      // 输入框
      .el-input__inner {
        height: 36px;
        line-height: 36px;
      }
      &.is-required:not(.is-no-asterisk) > .el-form-item__label {
        &::before {
          content: '';
        }
        &::after {
          content: '*';
          color: #ff2a46;
          margin-left: 2px;
        }
      }
      // 单选框
      .el-radio-group {
        .el-radio {
          color: @content-color;
          margin-right: 24px;
          .el-radio__input {
            .el-radio__label {
              padding-left: 8px;
            }
            .el-radio__inner {
              width: 16px;
              height: 16px;
              border: 1px solid @border-color;
            }
            &.is-checked {
              & + .el-radio__label {
                color: @primary-color;
              }
              .el-radio__inner {
                background: none;
                border-color: @primary-color;
                &::after {
                  content: '';
                  width: 8px;
                  height: 8px;
                  transform: translate(-50%, -50%);
                  border-radius: 50%;
                  background-color: @primary-color;
                }
              }
            }
          }
        }
      }
      // textarea
      .el-textarea__inner {
        font-family: '';
      }

      // 下拉
      .el-select {
        width: 100%;
      }
    }
  }
}
</style>
